import {
    Directive,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    Renderer2,
    SimpleChanges,
} from '@angular/core';

export interface DrawerOptions {
    property: 'left' | 'right';
    valueOpen: string;
    valueClose: string;
    focusOpen?: string;
    focusClose?: string;
}

@Directive({
    selector: '[cmps-drawer]',
    host: {
        '(keydown.esc)': 'close()',
    },
})
export class DrawerDirective implements OnChanges {
    @Input('cmps-drawer') options: DrawerOptions;
    @Input() open: boolean;
    @Output() openChange: EventEmitter<boolean>;

    private _didInitialRender: boolean;

    constructor(
        private readonly _el: ElementRef,
        private readonly _renderer2: Renderer2,
    ) {
        this.openChange = new EventEmitter();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this._render();
    }

    close(): void {
        this.open = false;
        this._render();
        this.openChange.emit(this.open);
    }

    private _focus(selector: string): void {
        if (this._didInitialRender && selector) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-unnecessary-type-assertion
            const el = <HTMLElement>document.querySelector(selector);
            if (el) el.focus();
        }
    }

    private _render(): void {
        const contents = this._el.nativeElement.querySelector(
            '.cmps-drawer-contents',
        );
        if (this.open) {
            this._renderer2.setStyle(contents, 'visibility', 'visible');
            this._renderer2.setStyle(
                this._el.nativeElement,
                this.options.property,
                this.options.valueOpen,
            );
            window.setTimeout(() => {
                this._renderer2.addClass(this._el.nativeElement, 'open');
                this._focus(this.options.focusOpen);
                this._didInitialRender = true;
            }, 200);
        } else {
            this._renderer2.setStyle(
                this._el.nativeElement,
                this.options.property,
                this.options.valueClose,
            );
            this._renderer2.removeClass(this._el.nativeElement, 'open');
            window.setTimeout(() => {
                this._renderer2.setStyle(contents, 'visibility', 'hidden');
                this._focus(this.options.focusClose);
                this._didInitialRender = true;
            }, 200);
        }
        this._renderer2.setAttribute(
            this._el.nativeElement,
            'aria-hidden',
            this.open ? 'false' : 'true',
        );
    }
}
